import { useEffect, useState } from "react";
import {
  Drawer,
  DrawerContent,
  DrawerLink,
  DrawerLinks,
  DrawerRow,
} from "../styled/Header.styled";
import { MENU_BY_TITLE, getHeaderLink, hasHeading } from "./data";

export const PCDrawer = ({ isOpen, content, onMouseEnter, onMouseLeave }) => {
  const [drawerContent, setDrawerContent] = useState(null);

  useEffect(() => {
    setDrawerContent(content ? MENU_BY_TITLE[content] : null);
  }, [content]);

  return (
    <Drawer
      className={isOpen ? "open" : "close"}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <DrawerContent>
        <DrawerRow>
          {content &&
            drawerContent &&
            Object.entries(drawerContent).map(([category, items]) => (
              <DrawerLinks key={category}>
                {hasHeading(category) ? (
                  <a href={getHeaderLink(category)} className="link-title">
                    {category}
                  </a>
                ) : (
                  /* parent's third PLANS column / second BENEFITS column carries no heading */
                  <span className="link-title-spacer" aria-hidden="true" />
                )}
                {items.map((item, index) => (
                  <DrawerLink key={index}>
                    <a href={item.link}>{item.title}</a>
                  </DrawerLink>
                ))}
              </DrawerLinks>
            ))}
        </DrawerRow>
      </DrawerContent>
    </Drawer>
  );
};
